const block = document.querySelector('section.employees');

if(block) {
  const moreBtn = block.querySelector('.expand-btn');
  if(moreBtn) {
    const employees = Array.from(block.querySelectorAll('.employee'));

    moreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const isExpanded = moreBtn.classList.toggle('expanded');
      employees.forEach((employee, index) => {
        if (index >= 3) {
          employee.classList.toggle('show', isExpanded);
        }
      });
    });
  }
}